import { State } from 'src/types'

export const webDrawUtil = (state: State) => {
  const isUnselectedWeb2 = state?.web2?.value === 'unselected'
  const web2Color = isUnselectedWeb2 ? state?.web?.color : state?.web2?.color
  const webColor = state.web?.color
  const laceColor = state.lace?.color
  const stitchColor = state.stitch?.color
  const edgeColor = state.edge?.color
  const defaultWeb = state.webParts?.value === 'unselected' && state.baseModel.webParts
  const webParts = state.webParts?.value || defaultWeb
  const productNumber = state.baseModel.productNumber
  const webMatcher = (webs: string[]) => webs.some((x) => [state.webParts?.value, defaultWeb].includes(x))
  return { webMatcher, webColor, web2Color, laceColor, stitchColor, edgeColor, webParts, productNumber }
}
